import { SettingsPage } from "@/components/settings/settings-page";

export default function Settings() {
  return <SettingsPage />;
}
